<template>
  <div class="search_form">
    <div class="form_row boolean_row">
      <label>Vir podatkov:</label>
      <select :value="sourceType" @change="setSourceType($event.target.value)">
        <option value="main">Vprašalnik</option>
        <option value="table2">Tabela 2</option>
        <option value="table3">Tabela 3</option>
      </select>
    </div>
    <div class="form_row boolean_row">
      <label v-if="isStaticSource">Način pregleda:</label>
      <select v-if="isStaticSource" :value="tableViewMode" @change="setTableViewMode($event.target.value)">
        <option value="by_row">Po vrsticah</option>
        <option value="by_column">Po stolpcih</option>
      </select>
    </div>

    <div class="form_row">
      <label>Iskanje po ključnih besedah</label>
      <textarea :value="form.search" rows="1" placeholder="npr. kakovost, internacionalizacija, …"
        @input="setFormField('search', $event.target.value)"></textarea>
    </div>

    <div v-if="showQuestionField" class="form_row">
      <label>Iskanje po pomenu (tema, vprašanje ali opis)</label>
      <textarea :value="form.question" rows="2"
        placeholder="Poišče dokumente s podobno vsebino, tudi brez ključnih besed - npr. Kako se ocenjuje kakovost? ali: izbirni predmeti in prilagoditve."
        @input="setFormField('question', $event.target.value)"></textarea>
    </div>

    <div class="form_section">
      <h4 class="form_section_title centered">Filtriranje</h4>
      <div v-if="filterOptionsLoading" class="filter_loading">Nalagam možnosti…</div>
      <template v-else-if="filterOptions">
        <div v-if="isStaticSource && tableViewMode === 'by_column'" class="form_row">
          <label>Stolpci</label>
          <SearchableMultiSelect :options="staticColumnOptions" value-key="value" label-key="label"
            :model-value="selectedStaticColumns" placeholder="Išči in izberi stolpce"
            @update:model-value="setSelectedStaticColumns($event)" />
        </div>

        <div class="form_row">
          <label>Program</label>
          <SearchableMultiSelect :options="filterOptions.ul_program_id || []" value-key="value" label-key="name"
            :model-value="filterSelections.ul_program_id" placeholder="Išči in izberi programe"
            @update:model-value="setFilterSelection('ul_program_id', $event)" />
        </div>

        <div class="form_row">
          <label>Leto</label>
          <SearchableMultiSelect :options="yearsOptions" value-key="value" label-key="label"
            :model-value="filterSelections.year_start" placeholder="Išči in izberi leta"
            @update:model-value="setFilterSelection('year_start', $event)" />
        </div>

        <div class="form_row">
          <label>Članica</label>
          <SearchableMultiSelect :options="facultiesOptions" value-key="value" label-key="label"
            :model-value="filterSelections.faculty_id" placeholder="Išči in izberi fakultete"
            @update:model-value="setFilterSelection('faculty_id', $event)" />
        </div>

        <div v-if="showSepPageFilter" class="form_row">
          <label>{{ isStaticSource ? 'Rubrika, kateri pripada vrstica' : 'Rubrika' }}</label>
          <SearchableMultiSelect :options="sepPageOptions" value-key="value" label-key="label"
            :model-value="filterSelections.sep_page_internal_id" placeholder="Išči in izberi rubrike"
            @update:model-value="setFilterSelection('sep_page_internal_id', $event)" />
        </div>

        <div v-if="showQInternalIdFilter" class="form_row">
          <label>Vprašanje</label>
          <SearchableMultiSelect :options="filterOptions.q_internal_id || []" value-key="value" label-key="label"
            :model-value="filterSelections.q_internal_id" placeholder="Išči in izberi vprašanja"
            @update:model-value="setFilterSelection('q_internal_id', $event)" />
        </div>

        <div class="form_row">
          <label>Stopnja programa</label>
          <SearchableMultiSelect :options="(filterOptions.program_stopnja || []).map(v => ({ value: v, label: v }))"
            value-key="value" label-key="label" :model-value="filterSelections.program_stopnja"
            placeholder="Išči in izberi stopnje programov"
            @update:model-value="setFilterSelection('program_stopnja', $event)" />
        </div>

        <div class="form_row">
          <label>Vrsta programa</label>
          <SearchableMultiSelect :options="(filterOptions.program_vrsta || []).map(v => ({ value: v, label: v }))"
            value-key="value" label-key="label" :model-value="filterSelections.program_vrsta"
            placeholder="Išči in izberi vrste programov"
            @update:model-value="setFilterSelection('program_vrsta', $event)" />
        </div>

        <div v-for="field in visibleBooleanFilterFields" :key="field" class="form_row boolean_row">
          <label>{{ booleanFieldLabels[field] || field }}</label>
          <select :value="booleanFilters[field]" class="boolean_select"
            @change="setBooleanFilter(field, $event.target.value)">
            <option value="vsi">Vsi</option>
            <option value="da">Da</option>
            <option value="ne">Ne</option>
          </select>
        </div>

      </template>
    </div>

    <div class="form_section">
      <h4 class="form_section_title centered">Tabele sumarnih podatkov</h4>
      <div class="checkbox_group">
        <label v-for="item in facetableFieldKeys" :key="'facet-' + item.value" class="checkbox_label">
          <input type="checkbox" :value="item.value" :checked="selectedFacets.includes(item.value)"
            @change="toggleMulti(selectedFacets, item.value, 'selectedFacets')" />
          {{ item.label }}
        </label>
      </div>
    </div>

    <div class="form_section">
      <h4 class="form_section_title centered">Vrni podatke</h4>
      <div class="checkbox_group">
        <label v-for="item in searchableFieldKeys" :key="'select-' + item.value" class="checkbox_label">
          <input type="checkbox" :value="item.value" :checked="selectedSelect.includes(item.value)"
            @change="toggleMulti(selectedSelect, item.value, 'selectedSelect')" />
          {{ item.label }}
        </label>
      </div>
    </div>

    <div class="form_row inline">
      <label>Največje število rezultatov</label>
      <input :value="form.top" type="number" min="0" max="1000"
        @input="setFormField('top', Number($event.target.value))" />
      <label>Preskoči N rezultatov</label>
      <input :value="form.skip" type="number" min="0" @input="setFormField('skip', Number($event.target.value))" />
    </div>

    <div class="form_actions">
      <button type="button" class="button button_with_loading" :class="{ disabled: loading }" @click="runSearch"
        :disabled="loading">
        <font-awesome-icon v-if="loading" :icon="['fas', 'spinner']" spin class="btn_loading_icon" aria-hidden="true" />
        <span>{{ loading ? 'Isčem …' : 'Iskanje rezultatov' }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import SearchableMultiSelect from '../general/SearchableMultiSelect.vue';

const FACETABLE_FIELD_KEYS = [
  { value: 'year', label: 'Leto' },
  { value: 'faculty_acronym', label: 'Članica' },
  { value: 'ul_program_id', label: 'Šifra programa' },
  { value: 'program_stopnja', label: 'Stopnja programa' },
  { value: 'program_vrsta', label: 'Vrsta programa' },
  { value: 'q_internal_id', label: 'Vprašanje' },
  { value: 'sep_page_internal_id', label: 'Rubrika' }
];

const SEARCHABLE_FIELD_KEYS = [
  { value: 'content', label: 'Vsebina odgovora' },
  { value: '__columns_content__', label: 'Vsebina po stolpcih' },
  { value: 'id', label: 'ID rezultata' },
  { value: 'year', label: 'Leto' },
  { value: 'faculty_acronym', label: 'Članica' },
  { value: 'ul_program_id', label: 'Šifra programa' },
  { value: 'ul_program_id_origin', label: 'Stara šifra programa' },
  { value: 'program_name', label: 'Program' },
  { value: 'program_stopnja', label: 'Stopnja programa' },
  { value: 'program_vrsta', label: 'Vrsta programa' },
  { value: 'program_finished', label: 'Program zaključen' },
  { value: 'program_extended', label: 'Program izpolnjen za dve leti' },
  { value: 'program_sample_evalvation', label: 'Vzorčna evalvacija' },
  { value: 'program_dvopredmetni', label: 'Dvopredmetni program' },
  { value: 'program_pedagoski', label: 'Pedagoski program' },
  { value: 'program_interdisciplinarni', label: 'Interdisciplinarni program' },
  { value: 'program_skupni', label: 'Skupni program' },
  { value: 'sep_page_name', label: 'Rubrika' },
  { value: 'q_title', label: 'Vprašanje' }
];

const BOOLEAN_FILTER_FIELDS = ['q_has_answer', 'program_finished', 'program_sample_evalvation', 'st_row_filled'];
const BOOLEAN_FIELD_LABELS = {
  q_has_answer: 'Ima odgovor:',
  st_row_filled: 'Izpolnjen najmanj en stolpec, razen drugega:',
  program_finished: 'Obrazec zaključen:',
  program_sample_evalvation: 'Vzorčna evalvacija:'
};

export default {
  components: { SearchableMultiSelect },
  data() {
    return {
      form: {
        search: '',
        question: '',
        orderBy: '',
        top: 10,
        skip: 0,
        count: true
      },
      filterSelections: {
        ul_program_id: [],
        year_start: [],
        faculty_id: [],
        sep_page_internal_id: [],
        q_internal_id: [],
        program_stopnja: [],
        program_vrsta: []
      },
      booleanFilters: { q_has_answer: 'da', st_row_filled: 'da', program_finished: 'vsi', program_sample_evalvation: 'vsi' },
      selectedFacets: [],
      selectedSelect: [],
      sourceType: 'main',
      tableViewMode: 'by_row',
      selectedStaticColumns: []
    };
  },
  mounted() {
    // Ensure filter options exist; store owns loading state
    if (!this.$store.getters.evalvation_filter_options && this.$store.getters.evalvation_filter_options_loading !== true) {
      this.$store.dispatch('evalvationAiFetchFilterOptions');
    }
  },
  computed: {
    facetableFieldKeys() {
      if (this.isStaticSource) {
        return FACETABLE_FIELD_KEYS.filter(item => item.value !== 'q_internal_id');
      }
      return FACETABLE_FIELD_KEYS;
    },
    searchableFieldKeys() {
      if (this.isStaticSource) {
        const hiddenForStatic = ['q_title'];
        if (this.sourceType === 'table2') {
          hiddenForStatic.push('sep_page_name');
        }
        return SEARCHABLE_FIELD_KEYS
          .filter(item => item.value !== 'q_title')
          .filter(item => !hiddenForStatic.includes(item.value))
          .map(item => item.value === 'content' ? { ...item, label: 'Vsebina vrstice' } : item);
      }
      return SEARCHABLE_FIELD_KEYS.filter(item => item.value !== '__columns_content__');
    },
    booleanFilterFields() { return BOOLEAN_FILTER_FIELDS; },
    visibleBooleanFilterFields() {
      if (this.sourceType === 'table3') return this.booleanFilterFields;
      return this.booleanFilterFields.filter(field => field !== 'st_row_filled');
    },
    booleanFieldLabels() { return BOOLEAN_FIELD_LABELS; },
    isStaticSource() {
      return this.sourceType !== 'main';
    },
    showQuestionField() {
      return !(this.isStaticSource && this.tableViewMode === 'by_column');
    },
    showQInternalIdFilter() {
      return !this.isStaticSource;
    },
    showSepPageFilter() {
      return this.sourceType !== 'table2';
    },
    sepPageOptions() {
      const base = Array.isArray(this.filterOptions?.sep_page_internal_id)
        ? [...this.filterOptions.sep_page_internal_id]
        : [];
      const hasGeneral = base.some(o => String(o.value) === 'general');
      if (!hasGeneral) {
        base.push({
          value: 'general',
          label: 'Splošno - ne pripada nobeni rubriki'
        });
      }
      return base;
    },
    staticColumnOptions() {
      const fields = this.filterOptions?.static_table_column_titles?.[this.sourceType]?.fields || {};
      const make = (n) => {
        const label = fields[`st_column${n}_text`] || `Stolpec ${n}`;
        return { value: `column${n}`, label };
      };
      if (this.sourceType === 'table2') return [make(1), make(2)];
      if (this.sourceType === 'table3') return [make(2), make(3), make(4), make(5), make(6), make(7)];
      return [];
    },
    filterOptions() {
      return this.$store.getters.evalvation_filter_options;
    },
    filterOptionsLoading() {
      return this.$store.getters.evalvation_filter_options_loading === true;
    },
    loading() {
      return this.$store.getters.evalvation_search_loading === true;
    },
    yearsOptions() {
      const years = this.$store.getters.getYears || {};
      return Object.keys(years).map(year => ({ value: year.substring(0, year.indexOf('/')), label: years[year] }));
    },
    facultiesOptions() {
      const faculties = this.$store.getters.getFaculties || {};
      return Object.keys(faculties).map(faculty => ({ value: faculties[faculty].id, label: faculties[faculty].acronym }));
    },
  },
  methods: {
    setFormField(key, value) {
      this.form = { ...this.form, [key]: value };
    },
    setSourceType(value) {
      this.sourceType = value;
      if (value === 'main') {
        this.tableViewMode = 'by_row';
        this.selectedStaticColumns = [];
      } else {
        const nextSelections = { ...this.filterSelections, q_internal_id: [] };
        if (value === 'table2') {
          nextSelections.sep_page_internal_id = [];
        }
        this.filterSelections = nextSelections;
        this.selectedSelect = this.selectedSelect.filter(v => v !== 'q_title');
      }
    },
    setTableViewMode(value) {
      this.tableViewMode = value;
      if (value === 'by_column') {
        this.form = { ...this.form, question: '' };
      }
    },
    setSelectedStaticColumns(value) {
      this.selectedStaticColumns = value;
    },
    setFilterSelection(key, value) {
      this.filterSelections = { ...this.filterSelections, [key]: value };
    },
    setBooleanFilter(key, value) {
      this.booleanFilters = { ...this.booleanFilters, [key]: value };
    },
    toggleMulti(arr, value, target) {
      const next = Array.isArray(arr) ? [...arr] : [];
      const idx = next.indexOf(value);
      if (idx === -1) next.push(value);
      else next.splice(idx, 1);
      if (target === 'selectedFacets') this.selectedFacets = next;
      if (target === 'selectedSelect') this.selectedSelect = next;
    },
    buildFilterString() {
      const clauses = [];
      const sel = this.filterSelections;
      if (this.sourceType === 'main') {
        clauses.push("doc_source eq 'main'");
      } else {
        clauses.push(`doc_source eq '${this.sourceType}'`);
      }
      const numFields = ['ul_program_id', 'year_start', 'faculty_id'];
      const strFields = ['program_stopnja', 'program_vrsta'];
      if (this.showSepPageFilter) strFields.push('sep_page_internal_id');
      if (!this.isStaticSource) strFields.push('q_internal_id');
      for (const field of numFields) {
        const arr = sel[field];
        if (arr && arr.length > 0) {
          const parts = arr.map(v => `${field} eq ${Number(v)}`);
          clauses.push('(' + parts.join(' or ') + ')');
        }
      }
      for (const field of strFields) {
        const arr = sel[field];
        if (arr && arr.length > 0) {
          const parts = arr.map(v => `${field} eq '${String(v).replace(/'/g, "''")}'`);
          clauses.push('(' + parts.join(' or ') + ')');
        }
      }
      for (const field of this.visibleBooleanFilterFields) {
        const v = this.booleanFilters[field];
        if (v === 'da') clauses.push(`${field} eq true`);
        else if (v === 'ne') clauses.push(`${field} eq false`);
      }
      return clauses.length > 0 ? clauses.join(' and ') : '';
    },
    runSearch() {
      const filterStr = this.buildFilterString();
      const facetsArr = this.selectedFacets && this.selectedFacets.length > 0
        ? this.selectedFacets
        : undefined;
      const rawSearch = this.form.search.trim();
      const searchValue = rawSearch || undefined;

      const expandSelectValues = [];
      const addUnique = (v) => {
        if (!expandSelectValues.includes(v)) expandSelectValues.push(v);
      };
      for (const item of this.selectedSelect) {
        if (item === '__columns_content__') {
          const cols = this.sourceType === 'table2'
            ? ['st_column1_text', 'st_column2_text']
            : ['st_column2_text', 'st_column3_text', 'st_column4_text', 'st_column5_text', 'st_column6_text', 'st_column7_text'];
          cols.forEach(addUnique);
        } else {
          addUnique(item);
        }
      }
      const selectStr = expandSelectValues.length > 0 ? expandSelectValues.join(',') : undefined;

      const questionPayload = this.showQuestionField ? (this.form.question.trim() || undefined) : undefined;

      const payload = {
        search: searchValue,
        question: questionPayload,
        filter: filterStr || undefined,
        orderby: this.form.orderBy.trim() || undefined,
        facets: facetsArr,
        select: selectStr,
        top: this.form.top,
        skip: this.form.skip,
        count: this.form.count,
        source: this.sourceType,
        table_view_mode: this.isStaticSource ? this.tableViewMode : undefined,
        static_columns: this.isStaticSource ? this.selectedStaticColumns : undefined
      };

      Object.keys(payload).forEach(k => payload[k] === undefined && delete payload[k]);
      this.$store.dispatch('evalvationAiSearch', payload);
    }
  }
};
</script>
